import { useContext, useEffect } from 'react'
import { ThemeContext } from '@vibialighting/ui-kit'
import Toggles from '@domain/toggles/Toggles'

// Punto ÚNICO y SIEMPRE montado (App root) que marca <body> con la clase del área profesional nueva
// (`emulate-new-menu`) + el tema (`np-dark`). Antes esto lo hacía ProfessionalShell, que se DESMONTA en
// las vistas con FullscreenLayerLayout (UsersManagement, configuradores…) y al limpiar quitaba la clase
// del <body>; entonces los portales (modales, dropdowns, drawers, tooltips) —que React monta colgando de
// <body>— perdían el reskin --np-* y caían a los colores legacy hardcodeados del ui-kit (dark azulado
// gray-1 #424b5a, acentos lima). Centralizado aquí, TODOS los portales heredan el tema en cualquier
// layout, con una sola fuente de color (los tokens --np-* de _new-pro-menu.scss).
//
// Gateado por el toggle: apagado → no se añade ninguna clase (legacy intacto, retrocompatible). El tema
// se lee del ThemeContext (lo fija useThemePreference en el shell y persiste aunque el shell se desmonte),
// así <body> y los modales (que leen el mismo ThemeContext vía withTheme) van siempre sincronizados.
const NewProMenuBodyClass = () => {
	const theme = useContext(ThemeContext)?.theme
	const enabled = Toggles.isEnabled('emulateNewMenuProfessional')

	useEffect(() => {
		const { classList } = document.body
		classList.toggle('emulate-new-menu', enabled)
		classList.toggle('np-dark', enabled && theme === 'dark')
	}, [enabled, theme])

	return null
}

export default NewProMenuBodyClass
